module.exports = __webpack_public_path__ + "img/top.5fe02f78.png";